__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "ttmx-front-multi-tenant-app";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query", "5.105.0", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(56), __webpack_require__.e(884), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(4056))))));
			register("axios", "1.20.0", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(69)]).then(() => (() => (__webpack_require__(7069))))));
			register("formik", "2.4.9", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(657), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(6291))))));
			register("i18next", "25.10.10", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(635)]).then(() => (() => (__webpack_require__(2635))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(961), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(961))))));
			register("react-hot-toast", "2.6.1", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(884), __webpack_require__.e(799)]).then(() => (() => (__webpack_require__(799))))));
			register("react-i18next", "16.6.6", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(270), __webpack_require__.e(884), __webpack_require__.e(652)]).then(() => (() => (__webpack_require__(9270))))));
			register("react-router-dom", "7.18.4", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(214), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(5214))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("styled-components", "6.6.0", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(267), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(8267))))));
			register("yup", "1.7.1", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(664)]).then(() => (() => (__webpack_require__(2664))))));
			register("zustand", "5.0.16", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(618)]).then(() => (() => (__webpack_require__(3237))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};